import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import './assets/scss/global.scss';
import { AppProviders } from './app/providers';
import { router } from './app/router';
import { initSentry } from './config/sentry';
import './i18n/config';

initSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </React.StrictMode>,
);
